// @ts-strict-ignore
/**
 * @owner @Appboy/billing
 */
import { messageArchivingConsumption } from "@dashboardApi/apis/messageArchivingConsumption/constants";
import { isMessageArchivingConsumptionResult } from "@dashboardApi/apis/messageArchivingConsumption/validators";

import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import type { MessageArchivingConsumptionParams, MessageArchivingConsumptionResult } from "./types";

export const getDataTableMessageArchivingConsumption = reactQueryTableFetcherAdapter(
  messageArchivingConsumption,
  (
    signal: AbortSignal,
    { appGroupId, query, groupby, limit = 20, sortby, sortdir, start = 0 }: MessageArchivingConsumptionParams
  ): Promise<MessageArchivingConsumptionResult> => {
    const { start_date, end_date, app_group: appGroup, channel: channel } = query;

    return fetch(
      `/analytics_dashboard/${appGroupId}/message_archiving_credit_consumption_detail_data`,
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        start_date: start_date,
        end_date: end_date,
        query: serializeQueryObjects({
          ...(appGroup && { app_group: appGroup }),
          ...(channel && { channel: channel }),
        }),
      },
      { signal }
    );
  },
  isMessageArchivingConsumptionResult
);
